import React, {ReactNode} from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'

export const ErrorMessagesLayout = ({
  titleSlot,
  descriptionSlot
}: {
  titleSlot: ReactNode
  descriptionSlot: ReactNode
}) => {
  return (
    <Box display="flex" flexDirection="column" paddingBottom="s500" gap="s300">
      <Box
        display="flex"
        alignItems="center"
        gap="s300"
        justifyContent="center"
      >
        <Icon name="Forbid" colorPath="content.danger.secondary" size="lg" />
        <Text variant="titleXL" align="center" dataId="errorMessage.title">
          {titleSlot}
        </Text>
      </Box>
      <Text
        variant="bodyM"
        colorPath="content.neutral.secondary"
        align="center"
        dataId="errorMessage.description"
      >
        {descriptionSlot}
      </Text>
    </Box>
  )
}
